import React, { Component } from "react";
import { connect } from "react-redux";
import { openArticleViewer } from "Actions";

import DrawerIframeComponent from "./DrawerIframeComponent";

export class DrawerIframe extends Component {
  render() {
    const { drawerIframe } = this.props;
    return <DrawerIframeComponent {...drawerIframe} />;
  }
}

// Connected Component
const mapStateToProps = state => ({
  drawerIframe: state.params.drawerIframe
});

export default connect(mapStateToProps)(DrawerIframe);



// WEBPACK FOOTER //
// ./src/components/Community/NewCommunity/DrawerIframe/index.js